export function parseRegex(patternInput) {
  if (!patternInput) {
    return null
  }

  if (patternInput.startsWith('/')) {
    const lastSlash = patternInput.lastIndexOf('/')
    if (lastSlash > 0) {
      const patternStr = patternInput.slice(1, lastSlash)
      const flags = patternInput.slice(lastSlash + 1)
      return new RegExp(patternStr, flags)
    }
  }

  let pattern = patternInput
  if (pattern.startsWith('^')) {
    pattern = pattern.slice(1)
  }
  if (pattern.endsWith('$')) {
    pattern = pattern.slice(0, -1)
  }

  return new RegExp(`^${pattern}$`)
}

export function testPattern(patternInput, value) {
  const regex = parseRegex(patternInput)
  if (!regex) {
    return true
  }

  return regex.test(value)
}
